import {
  BodyText,
  Button,
  Heading,
  Icon,
  IconSet,
  Image,
  Layout,
  ModalBody,
} from '@postscript/components';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { BRAND_CENTER_PATH } from 'components/brand/constants';
import { useGlobalModal } from 'components/GlobalModal/globalModal';
import { useUser } from 'controllers/contexts/user';

import BrandCenterPreview from 'img/brand-center-modal-horizontal.gif';

import {
  COMMON_EVENT_NAMES,
  logEvent,
  MODAL_TYPES,
  PRODUCT_AREAS,
} from 'utils/events';

const StyledInfoCardContainer = styled.div`
  background-color: var(--modal-bkg-color);
  bottom: 0;
  height: 347px;
  padding-top: var(--spacing-5);
  padding-right: var(--spacing-6);
  padding-left: var(--spacing-6);
  padding-bottom: var(--spacing-7);
  width: 100%;
`;

const ContinueToBrandCenterInfinityTestingModal = () => {
  const { user } = useUser();
  const { replace } = useHistory();
  const { hideModal } = useGlobalModal();

  const continueToBrandCenter = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    logEvent(COMMON_EVENT_NAMES.MODAL_CTA_CLICKED, {
      modal_type: MODAL_TYPES.INFINITY_TESTING,
      product_area: PRODUCT_AREAS.BILLING,
      shop_id: user.shop_id,
      text: (event.target as HTMLButtonElement).innerText,
    });

    hideModal();
    replace(BRAND_CENTER_PATH);
  };

  return (
    <ModalBody>
      <Icon
        component={IconSet.Close}
        size="large"
        onClick={() => replace(BRAND_CENTER_PATH)}
        style={{
          cursor: 'pointer',
          position: 'absolute',
          top: 10,
          right: 10,
          zIndex: 10,
          color: 'var(--gray-1)',
        }}
      />
      <Image
        height={280}
        alt="Brand Center Toggles"
        frame="square"
        src={BrandCenterPreview}
      />
      <StyledInfoCardContainer>
        <Heading size="x-small">
          🎉 Welcome to Your 30-Day Infinity Testing Trial!
        </Heading>
        <BodyText style={{ marginTop: 'var(--spacing-4)' }} size="small">
          You’re all set to explore Postscript’s Infinity Testing AI tools!
          Before you dive in, make sure your AI is speaking your language.
        </BodyText>
        <BodyText style={{ marginTop: 'var(--spacing-4)' }} size="small">
          Head over to the <strong>Brand Center</strong> to:
        </BodyText>
        <BodyText size="small" style={{ marginLeft: 'var(--spacing-4)' }}>
          <li>Set and adjust your brand voice and tone of communication.</li>
          <li>
            Review and manage brand links and documents to further train the AI.
          </li>
          <li>Align the AI’s suggestions with your unique brand identity.</li>
        </BodyText>
        <Layout align="center">
          <Button
            style={{ marginTop: 'var(--spacing-5)' }}
            onClick={continueToBrandCenter}
          >
            Continue to Brand Center
          </Button>
        </Layout>
      </StyledInfoCardContainer>
    </ModalBody>
  );
};

export default ContinueToBrandCenterInfinityTestingModal;
